import axios from 'axios';

const api_url = process.env.REACT_APP_API_URL;

export const getLanguagesList = async () => {
  return await axios.get(`${api_url}languages/`);
};
